import React, { useEffect, useState } from 'react'
import './user-dropdown.styles.scss'

import { Link } from 'react-router-dom'
import { version } from '@/changelog-version'
import { useSelector } from 'react-redux'

const UserDropdown = ({ 
    show,
    setShowDropdown 
}) => {
    
    const root = useSelector(state => state.userData.root);
    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const profile = useSelector(state => state.userData.userProfile);
    const [ isOfAge, setIsOfAge ] = useState(false);

    useEffect(() => {
        if (!profile) return;
        const now = new Date().getTime();
        const sixteenYrs = 31622400000 * 16;
        if (profile.birthday < now - sixteenYrs) {
            setIsOfAge(true);
        } else {
            setIsOfAge(false);
        }
    }, [profile]);
    

    return (
        <div className={`auth-dropdown-container ${show ? 'active' : ''} ${screenSize}`}>
            <div className={`auth-dropdown-menu ${screenSize}`}>
                <Link 
                    to='/home' 
                    className='menu-item'
                    onClick={() => setShowDropdown(false)} >
                    Your Games
                </Link>
                {
                    isOfAge && (
                        <Link 
                            to='/home/mycontent'
                            className='menu-item'
                            onClick={() => setShowDropdown(false)} >
                            Your Content
                        </Link>
                    )
                }
                <Link 
                    to='/profile'
                    className='menu-item'
                    onClick={() => setShowDropdown(false)} >
                    Your Profile
                </Link>
                {
                    isOfAge && (
                        <Link 
                            to='/plan'
                            className='menu-item'
                            onClick={() => setShowDropdown(false)} >
                            Your Plan
                        </Link>
                    )
                }
                {
                    isOfAge && (
                        <Link 
                            to ='/home/orgs'
                            className='menu-item'
                            onClick={() => setShowDropdown(false)} >
                            Your Organizations
                        </Link>
                    )
                }
                {/* {
                    (membership && membership.membership > 0) &&
                    <a href='https://billing.stripe.com/p/login/test_9AQ2aK2Nj3jaaYM9AA' target="_blank">Manage My Plan</a>
                } */}
                <Link 
                    to='/preview'
                    className='menu-item'
                    onClick={() => setShowDropdown(false)} >
                    Give it a Try!
                </Link>
                <Link 
                    to='/logout'
                    className='menu-item'
                    onClick={() => setShowDropdown(false)} >
                    Sign Out
                </Link>
                <div className='meta'>
                    <div className='version'>
                        {version}
                    </div>
                    <Link 
                        to='/changelog'
                        target='_blank'
                        onClick={() => setShowDropdown(false)} >
                        Change Log
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default UserDropdown